import React, { FC } from 'react';

import Styled from './style';
import useHook from './hook';
import AppButton from '../../shared/app-button';
import salesforce from '../../assets/images/salesforce-text.png';
import { AuthWrapper } from '../../shared/auth-wrapper';
import { Typography } from '../../shared/typography';
import colors from '../../assets/colors';

type IProps = {};

const DomainMissingPage: FC<IProps> = () => {
	const { state, user, salesforceLogin } = useHook();
	const { isSalesLoading } = state;

	const { firstName, lastName } = user;
	const fullName = `${firstName || ''} ${lastName || ''}`;

	const Mailto = ({ email, subject, body, children }: any) => {
		return (
			<a
				style={{ color: colors.black }}
				href={`mailto:${email}?subject=${
					encodeURIComponent(subject) || ''
				}&body=${encodeURIComponent(body) || ''}`}
			>
				{children}
			</a>
		);
	};

	return (
		<AuthWrapper>
			<Styled.Bottom>
				<Styled.WrapTitle>
					<Styled.Title
						text={'Your access request is underway!'}
						style={{ textAlign: 'center' }}
					/>
				</Styled.WrapTitle>
				<Styled.Content>
					<div style={{ width: '100%' }}>
						<Styled.Center>
							<Typography style={{ textAlign: 'center' }} size="large">
								To start using snaps and reports you need to connect Revvy to
								your CRM
							</Typography>
						</Styled.Center>
						<AppButton
							title="Sign up with"
							color="blue"
							imageLeft={false}
							isLoading={isSalesLoading}
							loaderColor="white"
							callBack={salesforceLogin}
							image={
								<img
									src={salesforce}
									style={{ height: 30, marginTop: 2 }}
									alt=""
								/>
							}
						/>
						<Styled.Separator>
							<Styled.Line />
							<Styled.SeparatorText
								type="title"
								size={'normal'}
								color={'btnTextGrey'}
								text="OR"
							/>
							<Styled.Line />
						</Styled.Separator>

						<Styled.Center>
							<Typography style={{ textAlign: 'center' }} size="large">
								Ask your company's Saleforce admin to sign and then join their
								team
							</Typography>
						</Styled.Center>
						<AppButton
							style={{ maxWidth: 475 }}
							color="lightGrey"
							titleColor="black"
							borderWidth={1}
							loaderColor="blue"
							type="bold"
							isBorder
						>
							<Mailto
								email=""
								subject="You’re invited to join Revvy!"
								body={`Hi there!

${fullName} from your company is inviting you to join Revvy!

What is Revvy? It’s a simple and intuitive way to generate reports from salesforce and other business application using voice and text commands.

Try it out! to get started all you need is an active salesforce license.

Link to Revvy here: https://app.getrevvy.com/login

-The Revvy team`}
							>
								Request to join
							</Mailto>
						</AppButton>
					</div>
				</Styled.Content>
			</Styled.Bottom>
		</AuthWrapper>
	);
};

export default DomainMissingPage;
